import { render, staticRenderFns } from "./SanctionAssignedTable.vue?vue&type=template&id=d1dc6300"
import script from "./SanctionAssignedTable.vue?vue&type=script&lang=js"
export * from "./SanctionAssignedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports